<template>
  <v-col cols="12" align="center">
    <div class="border-light border-radius-10">
      <div class="py-4 ordera-toolbar">
        <span :class="device.isDesktop ? '' : 'body-1'">
          {{ title || $t("pages.category_menu.sentence_1") }}
        </span>
      </div>
      <v-row
        no-gutters
        justify="center"
        align="center"
        class="py-4 bg-white border-radius-10"
      >
        <v-btn
          icon
          @click="subOneDay"
          class="category-menu-select-date-btn rounded-lg"
        >
          <v-icon color="primary">mdi-arrow-left</v-icon>
        </v-btn>
        <div class="px-4">
          <span
            class="font-weight-bold"
            :class="device.isDesktop ? '' : 'body-1'"
          >
            {{ translate(dayName(moment(selectedDate).format("dd"))) }} </span
          ><br />
          <span class="body-1 font-weight-bold grey--text text--darken-3">{{
            moment(selectedDate).format("DD.MM.YYYY.")
          }}</span>
        </div>
        <v-btn
          icon
          @click="addOneDay"
          class="category-menu-select-date-btn rounded-lg"
        >
          <v-icon color="primary">mdi-arrow-right</v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  props: {
    selectedDate: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      moment,
    };
  },
  methods: {
    dayName(date) {
      switch (date) {
        case "We":
          return this.$t("calendar.wednesday");
        case "Th":
          return this.$t("calendar.thursday");
        case "Fr":
          return this.$t("calendar.friday");
        case "Sa":
          return this.$t("calendar.saturday");
        case "Su":
          return this.$t("calendar.sunday");
        case "Mo":
          return this.$t("calendar.monday");
        case "Tu":
          return this.$t("calendar.tuesday");
      }
    },
    addOneDay() {
      this.$emit("addOneDay");
    },
    subOneDay() {
      this.$emit("subOneDay");
    },
  },
};
</script>

<style scoped>
.ordera-toolbar {
  background-color: #fff8f5;
  border-radius: 8px 8px 0px 0px;
}
.border-radius-10 {
  border-radius: 10px;
}
.border-light {
  border: 1px solid #0000001a;
}
.category-menu-select-date-btn {
  background-color: #fee2cf !important;
}
</style>
